<template>
    <div class="container">
        <div class="top">
            <img class="logo" src="@/assets/imgs/logo.png" alt="">
            <van-form @submit="onSubmit">
                <van-field
                    v-model="userphone"
                    name="userphone"
                    label="手机号"
                    type="tel"
                    placeholder="请输入手机号"
                    @blur="blurtest('phone')"
                    @focus="focustest('phone')"
                    class="borderBottom"
                >
                    <template #button>
                        <div >
                            <span class="red buttonText" v-if="phoneShow && userphone!==''">手机号码格式错误</span>
                            <span class="red buttonText" v-if="userphone!==''" @click="clearPhone()"><van-icon  name="clear" color="#999"/></span>
                        </div>
                    </template>
                </van-field>
                <van-field
                    v-model="password"
                    name="password"
                    label="验证码"
                    placeholder="请输入验证码"
                    maxlength="6"
                    type="digit"
                    @blur="blurtest('code')"
                    @focus="focustest('code')"
                    class="borderBottom code"
                >
                    <template #button>
                        <div>
                            <span class="red buttonText" v-if="codeShow && password!==''">验证码错误</span>
                            <span class="line"></span>
                            <div class="rightWidth">
                                <span class="red buttonText " v-if="timeShow">{{buttonText}}</span>
                                <span class="red buttonText" v-else @click="getLoginSmsCode()">{{buttonText}}</span>
                            </div>
                        </div>
                    </template>
                </van-field>
                <div class="btn loginBtn">
                    <van-button class="bgGray" :class="{bgRed:this.userphone!=''}" round block native-type="submit">登录</van-button>
                </div>
            </van-form>
            <div class="weixin">
                <p class="logoText">快速登陆</p>
                <div class="weixinBox" @click="weixinLogin()">
                    <img class="weixinImg" src="../../assets/imgs/weixin.png" alt="">
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
import {wxLogin} from '@/utils/util'
export default {
    data() {
        return {
            userphone: '',
            password: '',
            phoneShow:false,
            codeShow:false,
            pattern: /^1[3456789]\d{9}$/,
            pattern2:/^\d{6}$/,
            buttonText:'获取验证码',//获取验证码，重新获取
            timeShow:false, 
            domHeight: document.documentElement.clientHeight,  //默认屏幕高度
            showHeight: document.documentElement.clientHeight,   //实时屏幕高度
        };
    },
    created(){
        document.title="保险商城";
    },
    mounted(){
        window.onresize = () => {
            return (() => {
                this.showHeight = document.documentElement.clientHeight;//这里需要注意一下可视区高度。
            })();
        };
    },
    methods: {
        focustest(val){
            if(val=="phone"){
                this.phoneShow=false;
            }else{
                this.codeShow=false;
            }
        },
        blurtest(val){
            if(val=="phone"){
                if(this.pattern.test(this.userphone)){
                    this.phoneShow=false;
                }else{
                    this.phoneShow=true;
                }
            }else{
                console.log(val)
                if(this.pattern2.test(this.password)){
                    this.codeShow=false;
                }else{
                    this.codeShow=true;
                }
            }
        },
        clearPhone(){
            this.userphone=""
        },
        //微信登陆
        weixinLogin(){
            wxLogin();
        },
        //获取验证码
        getLoginSmsCode(){
            if(this.pattern.test(this.userphone)){
                this.$https.fetchPost("Login/getLoginSmsCode",{"mobile":this.userphone})
                .then(result=>{
                    let data=result.data;
                    console.log("phone",data)
                    if(data.code==1){
                        this.textNum();
                    }
                    Toast(data.msg);
                })
            }else{
                Toast("请输入正确的手机号");
            }
            
        },
        //发送验证码后到计数
        textNum(){
            let num=60;
            this.timeShow=!this.timeShow;
            let timer=setInterval(()=>{
                if(num==0){
                    this.buttonText="重新获取";
                    this.timeShow=!this.timeShow;
                    clearInterval(timer);
                }else{
                    this.buttonText=num+"s";
                }
                num--;
            },1000)
        },
        onSubmit(values) {
            this.$https.fetchPost("Login/smsLogin",{"mobile":this.userphone,"verification_code":this.password})
            .then(result=>{
                let data=result.data;
                if(data.code==1){
                    let userInfo=data.data
                    this.$store.commit("LOGIN",userInfo);
                    this.$router.push({ path: '/' });
                }
                Toast(data.msg);
            })
        },
    },
    computed:{
    }
}
</script>

<style scoped>
    /* .container{
        position: relative;
        width: 100vw;
        height: 100vh;
        background: #fff;
    } */
    .loginBtn{
        font-size:16px;
        font-weight:500;
    }
    .top{
        position: absolute;
        left: 0;
        right: 0;
        /* top: 8.5%; */
        top:40px;
    }
    .logo{
        width: 53%;
    }
    .van-form .btn{
        margin:40px 0;
    }
    .bgGray{
        color: #fff;
        background:rgba(222,222,222,1);
        font-size:16px;
        font-weight:500;
        height:45px;
    }
    .bgRed{
        background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
    }
    .borderBottom{
        border-bottom: 1px solid #F1F0F0;
    }
    .van-form{
        width: 85%;
        margin: 80px auto;
        text-align: start;

    }
    .van-form>div{
        margin: 15px 0;
    }
    .van-cell{
        display: block;
        padding-left: 6px;
        padding-right: 6px;
    }
   .van-cell /deep/ .van-cell__value {
        display: flex;
        justify-content: space-between;
        color: #333;
        position: relative;
    }
    .van-field--error /deep/ .van-field__control{
        color: #333;
    }
     /* .van-cell /deep/ .van-cell__value /deep/ .van-field__error-message{
        position: absolute;
        top: 0;
        right: 20px;
        color: #F34740;
     }
      .code.van-cell /deep/ .van-cell__value /deep/ .van-field__error-message{
        right: 70px;
     } */
      .van-cell /deep/ .van-cell__value /deep/ .van-field__body{
          width: 100%;
      }
      .van-cell /deep/ .van-cell__value /deep/ .van-field__body>input{
          font-size: 13px;
      }
    .van-cell /deep/ .van-field__label{
        font-size: 14px;
        color: #333;
    }
    .van-cell  /deep/ .van-field__control input{
        font-size: 13px;;
    }
    /* .van-field__body >>> .van-field__error-message{
        color: #F34740;
        position: absolute;
        right: 20px;
    } */
   
    .weixin{
        /* position: fixed;
        bottom: 4%; */
        width: 100%;
    }
    .logoText{
        color: #D5D5D5;
        font-size: 12px;
    }
    .weixinBox{
        width: 34px;
        margin: 0 auto;
    }
    .weixinImg{
        width: 100%;
    }
    .buttonText{
        font-size: 12px;
    }
     .rightWidth{
        display: inline-block;
        width: 70px;
        text-align: center;
    }
    .line{
        border-left:1px solid rgba(241,240,240,1);
        margin:0 5px
    }
    .van-icon{
        top:2px;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue